import inviteTypes from './inviteTypes';

export const inviteCustomer = (invite) => ({
  type: inviteTypes.INVITE_CUSTOMER_REQUEST,
  payload: { invite },
});
